import React from "react";
import PropTypes from "prop-types";
import { Schema } from "@sparefoot/react-commons";

const createSizeSlug = (size) => {
	if (!size) return "unit";
	return size.replace(/['\s]/g, "").toLowerCase();
};

const buildUnitSchema = (unit, facility, baseUrl) => {
	const rootUrl = baseUrl || "https://www.storage.com";
	const size = unit.sizeText || "Storage Unit";
	const sizeSlug = createSizeSlug(size);
	const amenities = unit.availableAmenities?.length
		? unit.availableAmenities.join(", ")
		: "secure storage";
	const price = unit.lowestPrice;
	const facilityUrl = `${rootUrl}${facility?.url || ""}`;

	return {
		"@context": "https://schema.org",
		"@type": "Product",
		"@id": `${facilityUrl}#${unit.id}#${sizeSlug}#product`,
		name: `${size} Storage Unit at ${facility?.name || "this facility"}`,
		description: `${size} storage unit with ${amenities}. Reserve online safely and conveniently at Storage.com.`,
		brand: {
			"@type": "Brand",
			name: facility?.name || "Storage.com"
		},
		offers: {
			"@type": "Offer",
			priceCurrency: "USD",
			...(price != null && { price: price.toString() }),
			availability:
				unit.quantity === 0
					? "https://schema.org/OutOfStock"
					: "https://schema.org/InStock",
			url: `${facilityUrl}#${sizeSlug}`,
			inventoryLevel: {
				"@type": "QuantitativeValue",
				value: unit.quantity ?? 1
			}
		}
	};
};

const FacilityUnitProductSchema = ({ units, facility, baseUrl }) => {
	if (!units?.length || !facility) return null;

	const schemas = units.filter(Boolean).map((unit) =>
		buildUnitSchema(unit, facility, baseUrl)
	);

	return (
		<>
			{schemas.map((schema) => (
				<Schema
					key={schema["@id"]}
					schema={schema}
				/>
			))}
		</>
	);
};

FacilityUnitProductSchema.propTypes = {
	units: PropTypes.arrayOf(PropTypes.object),
	facility: PropTypes.object.isRequired,
	baseUrl: PropTypes.string
};

export default FacilityUnitProductSchema;
